'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<path d="M6.83 16h10.406l2.454-9H5.143l1.687 9zM18 18H6a.997.997 0 0 1-.982-.816l-2.06-10.98-.007-.037L2.17 2H1a1 1 0 1 1 0-2h2c.481 0 .894.343.982.816L4.767 5H21a1 1 0 0 1 .965 1.263l-3 11A1 1 0 0 1 18 18zm0 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-9 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><!-- Filename: sourceSvg/account/cart.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};